import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ThreadsBarItem from './ThreadsBarItem';
import useGetUser from '@/api/queries/useGetUser';
import { ThreadObject } from '@/types';

interface ThreadContentProps {
  displayedItems: ThreadObject[];
  hasMore: boolean;
  scrollRef: (node: Element | null) => void;
  activeThreadId: string | null;
  goToThread: (thread_id: string) => void;
  activeTab: 'previous' | 'published';
}

const ThreadBarContent = ({
  displayedItems,
  hasMore,
  scrollRef,
  activeThreadId,
  goToThread,
  activeTab,
}: ThreadContentProps) => {
  const { data: user } = useGetUser();

  if (displayedItems.length === 0) {
    return (
      <div className="flex flex-col justify-center px-4 pt-4">
        <p className="text-center text-xs text-gray-500">
          {activeTab === 'previous'
            ? 'Your Kim questions will appear here'
            : 'Published Kim questions will appear here'}
        </p>
      </div>
    );
  }

  return (
    <>
      {displayedItems.map((threadObject: ThreadObject) => {
        return (
          <ThreadsBarItem
            key={threadObject.id}
            threadText={threadObject.name}
            threadId={threadObject.id}
            goToThread={goToThread}
            threadStatus={threadObject.status}
            isActive={threadObject.id === activeThreadId}
            createdAt={threadObject.createdDate.toString()}
            createdByEmail={threadObject.createdBy?.email}
            createdById={threadObject.createdById}
            activeTab={activeTab}
            userId={user?.id}
          />
        );
      })}
      {hasMore && (
        <div ref={scrollRef} className="mb-4 flex items-center justify-center">
          <FontAwesomeIcon icon={faCircleNotch} className="fa-spin text-brandSecondary" />
        </div>
      )}
    </>
  );
};

export default ThreadBarContent;
